import React, { Component } from "react";

import GroupEditCard from "../elements/GroupEditCard";
import classNames from "classnames";
import db from "../../api/db";

class Groups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      string: "",
      results: [],
      total: 0,
      id: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.setClear = this.setClear.bind(this);
  }

  componentDidMount() {
    const id = this.props.match.params.id ? this.props.match.params.id : "";
    this.setState({
      id: id
    });
    this.search_input.focus();
    this.searchQuery(this.state.string);
  }

  handleChange(event) {
    this.setClear();
    if (event.target.name === "string") {
      this.setState({
        string: event.target.value
      });
      this.searchQuery(event.target.value);
    }
  }

  searchQuery(string = this.state.string) {
    let query = {};

    if (string.length) {
      query["name"] = string;
    }

    db.query("group", query).then(response => {
      this.setState({
        results: response.data,
        total: response.data.length
      });
    });
  }

  setClear() {
    this.setState({
      id: ""
    });
    this.props.history.push("/groups");
  }

  setgroup(id) {
    this.setState({
      id: id
    });
    this.props.history.push(`/groups/${id}`);
  }

  createNew() {
    this.setState({
      id: "new"
    });
    this.props.history.push("/groups/new");
  }

  render() {
    let groups = "";

    if (this.state.total) {
      groups = this.state.results.map((item, i) => (
        <div
          key={i}
          data-id={item.id}
          onClick={e => this.setgroup(item.id)}
          className={classNames("item", {
            active: this.state.id === item.id
          })}
        >
          <div className="t2">{item.title}</div>
        </div>
      ));
    }
    return (
      <div className="main-container">
        <div className="primary-content">
          <div className="grid-x">
            <div className="medium-3 cell">
              <div className="sidebar-right listing">
                <button
                  className="float-right button link black"
                  onClick={e => this.createNew()}
                >
                  Opprett gruppe
                </button>
                <div className="heading">Velg gruppe</div>
                <label>
                  <input
                    className="search-input"
                    placeholder="Søk etter gruppe"
                    name="string"
                    type="text"
                    value={this.state.string}
                    onChange={this.handleChange}
                    ref={input => {
                      this.search_input = input;
                    }}
                  />
                </label>
                <div className="metainfo">
                  {this.state.total} grupper{" "}
                  {this.state.total > 40 ? "(Viser de 40 første)" : ""}
                </div>
                <div className="list">{groups}</div>
              </div>
            </div>
            <div className="medium-7 cell">
              {this.state.id ? (
                <GroupEditCard id={this.state.id} clear={this.setClear} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
/**/
export default Groups;
